const projects = [
      {
        "name": "VRVizX",
        "image": "https://i.ibb.co/XZFfDmx/vrvizx.png",
        "scrollable": true,
        "description": "Developed a VR prototype for Head-Mounted Displays (HMDs) to enhance data visualization, creating an intuitive, immersive environment for improved user comprehension and decision-making.",
        "gitUrl": "https://github.com/kushantha-sajith/VRVizX.git",
        "tech": [
          {
            "url": "",
            "name": "Unity"
          },
          {
            "url": "",
            "name": "C#"
          }          
        ]
      },
      {
        "name": "RCUAC",
        "image": "https://i.ibb.co/sFvwNTY/Screenshot-2025-01-09-013200.png",
        "scrollable": true,
        "description": "Designed a web application for RCUAC to manage attendance, track practice sessions and event participation, organize schedules, and generate insightful reports for streamlined club operations.",
        "livePreviewUrl": "https://rcuac.lk",
        "gitUrl": "https://github.com/rcuac-lk",
        "tech": [
          {
            "url": "svg/react-logo.svg",
            "name": "React.js"
          },
          {
            "url": "svg/tailwind-logo.svg",
            "name": "Tailwind CSS"
          },
          {
            "url": "svg/node-logo.svg",
            "name": "Node.js"
          },
          {
            "url": "svg/express-logo.svg",
            "name": "Express.js"
          },
          {
            "url": "svg/mysql-logo.svg",
            "name": "MySQL"
          }
        ]
      },
      {
        "name": "Emin Labs",
        "image": "https://i.ibb.co/BqrCTrQ/Screenshot-2025-01-09-013200.png",
        "scrollable": true,
        "description": "Designed a single-page website for a web development agency, showcasing services, expertise, portfolio, and contact details in a visually engaging layout, ensuring an impactful online presence.",
        "livePreviewUrl": "https://emin-labs.web.app/",
        "tech": [
          {
            "url": "svg/nextjs-logo.svg",
            "name": "Next.js"
          },
          {
            "url": "svg/tailwind-logo.svg",
            "name": "Tailwind CSS"
          }
        ]
      },
      {
        "name": "DonateUs",
        "image": "https://i.ibb.co/7pfKT78/Edge-Browsers-Dark-Mode.png",
        "scrollable": true,
        "description": "A web-based system streamlining donation management, allowing beneficiaries to request and donors to contribute seamlessly. Event coordinators can also seek support for donation events. The web application was developed without using any framework.",
        "gitUrl": "https://github.com/kushantha-sajith/DonateUs.git",
        "tech": [
          {
            "url": "svg/html-logo.svg",
            "name": "HTML"
          },
          {
            "url": "svg/css-logo.svg",
            "name": "CSS"
          },
          {
            "url": "svg/js-logo.svg",
            "name": "JavaScript"
          },
          {
            "url": "svg/php-logo.svg",
            "name": "PHP"
          },
          {
            "url": "svg/mysql-logo.svg",
            "name": "MySQL"
          }
        ]
      },
      {
        "name": "CuddleCare Web App",
        "image": "https://i.ibb.co/GQns6jP/CC-web-app.png",
        "scrollable": false,
        "description": "A comprehensive mobile and web application designed to effortlessly manage and track crucial baby care details. This intuitive system enables parents to record sleeping patterns, diaper changes, feeding schedules, symptoms, and expenses seamlessly.",
        "gitUrl": "https://github.com/Nareash503536/cuddlecare-backend.git",
        "livePreviewUrl": "https://cuddlecarebaby.web.app/",
        "tech": [
          {
            "url": "svg/react-logo.svg",
            "name": "React.js"
          },
          {
            "url": "svg/tailwind-logo.svg",
            "name": "Tailwind CSS"
          },
          {
            "url": "svg/spring-logo.svg",
            "name": "Spring Boot"
          },
          {
            "url": "svg/postgresql-logo.svg",
            "name": "PostgreSQL"
          }
        ]
      },
      {
        "name": "CuddleCare Mobile App",
        "image": "https://i.ibb.co/wCx4D98/CC-mobile-app.png",
        "scrollable": false,
        "description": "A comprehensive mobile and web application designed to effortlessly manage and track crucial baby care details. This intuitive system enables parents to record sleeping patterns, diaper changes, feeding schedules, symptoms, and expenses seamlessly.",
        "gitUrl": "https://github.com/Nareash503536/cuddlecare-mobile.git",
        "tech": [
          {
            "url": "svg/reactnative-logo.svg",
            "name": "React Native"
          },
          {
            "url": "svg/tailwind-logo.svg",
            "name": "Nativewind CSS"
          },
          {
            "url": "svg/spring-logo.svg",
            "name": "Spring Boot"
          },
          {
            "url": "svg/postgresql-logo.svg",
            "name": "PostgreSQL"
          }
        ]
      },
      {
        "name": "Supply Chain Management System",
        "image": "https://i.ibb.co/gW1KVrG/scm.png",
        "scrollable": true,
        "description": "Developed a supply chain management system to optimize production and distribution. It tracks inventory levels and ensures smooth operations and cost-effective processes.",
        "gitUrl": "https://github.com/kushantha-sajith/Supply_Management_System.git",
        "tech": [
          {
            "url": "svg/html-logo.svg",
            "name": "HTML"
          },
          {
            "url": "svg/css-logo.svg",
            "name": "CSS"
          },
          {
            "url": "svg/js-logo.svg",
            "name": "JavaScript"
          },
          {
            "url": "svg/php-logo.svg",
            "name": "PHP"
          },
          {
            "url": "svg/mysql-logo.svg",
            "name": "MySQL"
          }
        ]
      },
      {
        "name": "Library Management System",
        "image": "https://i.ibb.co/qBCnSM3/lms.png",
        "scrollable": true,
        "description": "Developed a library management system to catalog books efficiently and manage user records. It allows users to borrow, and return while enabling librarians to monitor inventory.",
        "gitUrl": "https://github.com/kushantha-sajith/Library_Management_System.git",
        "tech": [
          {
            "url": "svg/java-logo.svg",
            "name": "Java"
          },
          {
            "url": "svg/mysql-logo.svg",
            "name": "MySQL"
          }
        ]
      },
      // {
      //   "name": "Personal Portfolio",
      //   "image": "https://media.graphassets.com/oVCgvmLfQuAeaFETNxGq",
      //   "scrollable": true,
      //   "description": "My personal portfolio is a testament to my commitment to excellence, featuring a collection of my finest works that showcase my skills, and unwavering passion for success",
      //   "livePreviewUrl": "https://kushantha-sajith.web.app/",
      //   "gitUrl": "#",
      //   "behanceUrl": "https://www.behance.net/gallery/166867923/Developer-Portfolio",
      //   "tech": [
      //     {
      //       "url": "https://media.graphassets.com/B4UrtyQTdCvdewenhysg",
      //       "name": "React"
      //     },
      //     {
      //       "url": "https://media.graphassets.com/XeofOFxfR8Oa2qeXdfOV",
      //       "name": "Tailwind CSS"
      //     },
      //     {
      //       "url": "https://media.graphassets.com/OqkjljsPTqOBeGbmXMSm",
      //       "name": "GraphQL"
      //     },
      //     {
      //       "url": "https://media.graphassets.com/eB4Z8i5Ti6hN8GiYuhFF",
      //       "name": "Material UI"
      //     }
      //   ]
      // }
];

export default projects;